var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComponentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.514 6.30895L21.285 11.5709C21.3591 11.6153 21.4205 11.6782 21.4631 11.7534C21.5058 11.8286 21.5282 11.9135 21.5282 11.9999C21.5282 12.0864 21.5058 12.1713 21.4631 12.2465C21.4205 12.3217 21.3591 12.3846 21.285 12.4289L12 17.9999L2.71498 12.4289C2.64082 12.3846 2.57944 12.3217 2.53682 12.2465C2.4942 12.1713 2.4718 12.0864 2.4718 11.9999C2.4718 11.9135 2.4942 11.8286 2.53682 11.7534C2.57944 11.6782 2.64082 11.6153 2.71498 11.5709L11.485 6.30895C11.6405 6.2155 11.8185 6.16614 12 6.16614C12.1814 6.16614 12.3594 6.2155 12.515 6.30895H12.514ZM12 8.33195L5.88698 11.9999L12 15.6679L18.113 11.9999L12 8.33195Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentIcon);
export default __webpack_public_path__ + "static/media/component-icon.5dc8b8732bec280966aab39ed575c9d4.svg";
export { ForwardRef as ReactComponent };